import TirePatternAPI from 'api/tire-pattern.api';
import { BaseHandler } from './base.handler';
import {
  setTirePatterns,
  setTirePatternPositions,
} from 'store/tire-pattern.slice';
import { setMakeModelDetails } from 'store/make-model-details.slice';

export default class TirePatternHandler extends BaseHandler {
  private readonly api: TirePatternAPI;
  constructor() {
    super();
    this.api = new TirePatternAPI();
  }

  async get() {
    try {
      const response = await this.api.getTirePatterns();
      const { makeModelDetails, tirePatternPositions, tirePatterns } = response;
      this.dispatch(setTirePatterns(tirePatterns));
      this.dispatch(setTirePatternPositions(tirePatternPositions));
      this.dispatch(setMakeModelDetails(makeModelDetails));
      return response;
    } catch (error) {
      console.error('Error fetching Tire Pattern:', error);
      throw error;
    }
  }
}
